import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/contexts/LanguageContext";
import { CheckCircle, XCircle, Clock } from "@phosphor-icons/react";

export default function PaymentResult({ status }) {
  const [params] = useSearchParams();
  const { t } = useTranslation();
  const orderId = params.get("external_reference") || params.get("order_id") || "";

  const STATUS_MAP = {
    success: { icon: CheckCircle, color: "text-green-400", title: t("payment_success_title"), msg: t("payment_success_msg") },
    failure: { icon: XCircle, color: "text-red-400", title: t("payment_failure_title"), msg: t("payment_failure_msg") },
    pending: { icon: Clock, color: "text-yellow-400", title: t("payment_pending_title"), msg: t("payment_pending_msg") },
  };

  const s = STATUS_MAP[status] || STATUS_MAP.pending;
  const Icon = s.icon;

  return (
    <main className="pt-20 min-h-screen flex items-center justify-center px-6" data-testid="payment-result-page">
      <div className="text-center max-w-md">
        <Icon size={64} weight="fill" className={`${s.color} mx-auto mb-6`} />
        <h1 className="text-3xl font-black uppercase font-['Cabinet_Grotesk'] mb-3">{s.title}</h1>
        <p className="text-gray-400 mb-2">{s.msg}</p>
        {orderId && <p className="text-xs text-gray-500 mb-6">{t("order_label")}: {orderId.slice(0, 8)}</p>}
        <div className="flex justify-center gap-4 mt-6">
          <Link to="/tienda"><Button className="bg-[#FF4D00] hover:bg-[#E64500] text-white font-bold">{t("back_to_store")}</Button></Link>
          <Link to="/"><Button variant="outline" className="border-white/20 text-white">{t("home")}</Button></Link>
        </div>
      </div>
    </main>
  );
}
